export enum MathTopicEvents {
  CLICKED_MAIN_MATH_TOPIC = `click_topic`,
  CLICKED_TOPIC_PRODUCT = `click_product`,
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type MathTopicParamObject = {
  topic?: string
  category?: string
  title?: string
}
